import React from 'react';
import { useAuth } from './AuthContext';
import AuthModal from '../components/AuthModal/AuthModal';

// Renders the global auth modal whenever AuthContext requests it (manual open,
// token expiry, or a 401 from the API layer). Mounted once, high in the tree.
export default function AuthModalHost() {
    const { authModalMode, closeAuthModal } = useAuth();
    if (!authModalMode) return null;
    return <AuthModal initialMode={authModalMode} onClose={closeAuthModal} />;
}
